module.exports = __webpack_public_path__ + "static/media/barcode.en.v2.887effea.png";